const FIREBASE_CONFIG = {
  apiKey: "AIzaSyCfOlDuS7rZfR9dmODtw9ReE8U-hCrzlJg",
  authDomain: "humanitas-ssn-lp-prod.com",
  databaseURL: "https://humanitas-ssn-lp-prod.firebaseio.com",
  projectId: "humanitas-ssn-lp-prod",
  storageBucket: "humanitas-ssn-lp-prod.appspot.com",
  messagingSenderId: "717730697680"
};

const DEFAULT_FILES_BUCKET = "gs://humanitas-ssn-lp-prod-defaultfiles";

const PROD_ENV = {
  FIREBASE_CONFIG,
  DEFAULT_FILES_BUCKET
};

export { PROD_ENV };



// WEBPACK FOOTER //
// ./src/config/prod.js